import { postListFetcher } from '@/shared/api/list';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { markFilter, typeFilter } from './filters';

interface Model extends ListRow {
  id: number;
  name: string;
  mark?: { name?: string; type?: string } | null;
}

const config: ListPageConfig<Model> = {
  queryKey: 'car-models',
  title: 'Справочник авто',
  boxTitle: 'Модель',
  errorText: 'Ошибка загрузки моделей',
  fetchList: postListFetcher('/car/model/list/'),
  rows: ['models'],
  searchKeys: [
    { value: 'id', label: 'Поиск по id' },
    { value: 'name', label: 'Поиск по модели' },
  ],
  filters: [typeFilter, markFilter],
  columns: [
    { header: 'id', sortField: 'id', render: (model) => model.id },
    { header: 'Модель', sortField: 'name', render: (model) => model.name },
    { header: 'Марка', sortField: 'mark_id', render: (model) => model.mark?.name ?? 'No mark' },
    { header: 'Тип', sortField: 'type_id', render: (model) => model.mark?.type ?? 'No mark' },
  ],
};

export const ModelsPage = () => <GenericListPage config={config} />;
